import { css } from '@emotion/react'
import { observer } from 'mobx-react'

import { commonRepo } from '~/@common/services/repo.service'

import AssignedLearningSection from './@widgets/AssignedLearning/AssignedLearningSection'
import DailyLearningLockedSection from './@widgets/DailyLearning/DailyLearningLockedSection'
import RecentChallengeByCurriculumSection from './@widgets/RecentChallengeByCurriculum/RecentChallengeByCurriculumSection'

const SimpleHomePage = () => {
  const { byFeature, isDailyWorksheetAllowed } = commonRepo.permission
  const isAssignedLearningEnabled = byFeature.isAllowed('CHALLENGE_SETTING')
  const isRemasterSmileChallengeEnabled = byFeature.isAllowed('REMASTER_SMILE_CHALLENGE')

  return (
    <div css={S.Container}>
      <header>선생님이 설정한 공부를 시작해볼까요?</header>
      <div css={S.Contents}>
        <div className="left-contents">
          {isAssignedLearningEnabled && <AssignedLearningSection />}
          {isRemasterSmileChallengeEnabled && <RecentChallengeByCurriculumSection />}
        </div>
        {isDailyWorksheetAllowed && <DailyLearningLockedSection />}
      </div>
    </div>
  )
}

export default observer(SimpleHomePage)

const S = {
  Container: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    padding: 20px 0 15px;
    gap: 20px;

    > header {
      color: var(--Colors-Gray-900);
      font-size: 28px;
      font-style: normal;
      font-family: Paperlogy;
    }
  `,
  Contents: css`
    display: flex;
    height: 100%;
    gap: 20px;

    .left-contents {
      display: flex;
      flex-direction: column;
      gap: 20px;
      width: 100%;
      height: 100%;
    }
  `,
}
